import { render, staticRenderFns } from "./YourEstateAgent.vue?vue&type=template&id=71ffecfc&scoped=true&"
import script from "./YourEstateAgent.vue?vue&type=script&lang=js&"
export * from "./YourEstateAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ffecfc",
  null
  
)

export default component.exports